import { prodAction, ProductionStep } from 'models/order';
import { RestorationPriceRow } from 'utils/restoration-price-rows';

export const computeProductionValueSteps = (
    action: prodAction,
    row: Pick<RestorationPriceRow, 'unitPrice' | 'quantity'>,
    steps: ProductionStep[],
): ProductionStep[] => {
    const deductionValue = action.productionDeductionValue || 0;
    const baseActionValue = (row.unitPrice - deductionValue) * (row.quantity || 1);

    return steps.map((step) => ({
        step: step.step,
        department: step.department,
        technician: step.technician,
        valuePercent: step.valuePercent || 0,
        stepValue: baseActionValue * ((step.valuePercent || 0) / 100),
        stepDeductionValue: deductionValue * ((step.valuePercent || 0) / 100),
    }));
};
